import { render } from "./StorePricingConfig.vue?vue&type=template&id=700c6e85&scoped=true"
import script from "./StorePricingConfig.vue?vue&type=script&lang=js"
export * from "./StorePricingConfig.vue?vue&type=script&lang=js"

import "./StorePricingConfig.vue?vue&type=style&index=0&id=700c6e85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700c6e85"]])

export default __exports__